import * as React from "react";

import { ILeanSvgIconWithColor } from "../ILeanSvgIconWithColor";

export const plus_small: React.FunctionComponent<ILeanSvgIconWithColor> = ({ iconColor, strokeWidth, ...rest }) => {
  return (
    <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 24 24" {...rest}>
      <path
        fill="none"
        stroke={iconColor}
        strokeWidth={strokeWidth}
        d="M11.5,20.9997 L11.5,3.9997 M20,12.5002 L3,12.5002"
      />
    </svg>
  );
};
